import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SurveyView from '../views/SurveyView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'survey',
    component: SurveyView,
    beforeEnter: (to, from, next) => {
      if (to.query.unsubscribe !== undefined) {
        next({ name: 'unsubscribe', query: to.query })
      } else if (to.query.survey === 'question') {
        next()
      } else {
        next({ name: 'home', params: { key: '' }, query: to.query })
      }
    }
  },
  {
    path: '/unsubscribe',
    name: 'unsubscribe',
    component: HomeView
  },
  {
    path: '/:key(.*)',
    name: 'home',
    component: HomeView,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
